// extracted by mini-css-extract-plugin
module.exports = {"label":"FieldWithLabel-label","textAreaLabel":"FieldWithLabel-textAreaLabel"};